import { IPDFMatching } from "../bulk-upload-pdf-files-step.component";

export abstract class MatchPotentialItemPipe {

    protected getItems(fileName: string='', fieldName: keyof IPDFMatching, PDFMatching: IPDFMatching[] = []  ):  number[] | string[] {
        if(fieldName && fieldName){
            const fileItems = PDFMatching.find(x=>x.filename === fileName);
            if (fileItems){
                if( Object.prototype.hasOwnProperty.call(fileItems, fieldName)){
                    return fileItems[fieldName] as number[];
                }
            }
        }

        return [];
    }
}